import moment from "moment";

// Use ISO format to avoid deprecation warnings
export const currentDate = moment().format();
export const nextday = moment().add(1, "days").format("YYYY-MM-DD");

export const today = moment().format("dddd");
export const tomorrow = moment().add(1, "days").format("dddd");

export const CurrentDatee = moment().format();

export const todayTime = moment().format("HH:mm");

// Legacy format exports for backward compatibility
export const currentDateLegacy = moment().format("YYYY/MM/DD HH:mm");
export const nextdayLegacy = moment().add(1, "days").format("YYYY/MM/DD");
